import { Component, EventEmitter, Input, Output } from '@angular/core'
import { GRID_VIEW, LIST_VIEW } from '../../../core/helpers/theme-config';
import { BehaviorSubject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';

@Component({
  selector: 'app-view-type-switch',
  templateUrl: './view-type-switch.component.html',
  styleUrls: ['./view-type-switch.component.scss']
})
export class ViewTypeSwitchComponent {
  @Input() viewType: string
  @Output() onTypeSwitched = new EventEmitter<string>()
  @Output() onToggleFullWidthView = new EventEmitter<boolean>()

  fullWidthView$ = new BehaviorSubject<boolean>(false)

  constructor(private store: Store<any>) {
    store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )
      .subscribe(this.fullWidthView$)
  }

  toggleFullWidthView() {
    this.onToggleFullWidthView.emit(!this.fullWidthView$.getValue())
  }

  get isGridView(): boolean {
    return this.viewType === GRID_VIEW
  }

  get isListView(): boolean {
    return this.viewType === LIST_VIEW
  }

  setGrid() {
    if(this.isListView)
      this.onTypeSwitched.emit(GRID_VIEW)
  }

  setList() {
    if(this.isGridView)
      this.onTypeSwitched.emit(LIST_VIEW)
  }
}
